module.exports = __webpack_public_path__ + "img/5B574E_586967_807C6F_6A746C-256px.0357309d.png";